import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { } from '@angular/google-maps';

@Component({
  selector: 'app-gmap-view',
  templateUrl: './gmap-view.component.html',
  styleUrls: ['./gmap-view.component.scss']
})
export class GmapViewComponent implements OnInit {
  @Input() mapData: any
  @Output() closeMapDialogue = new EventEmitter<any>();

  map: any;
  kmlUrl2: any;
  georssLayer: any

  showMap: boolean = true
  mapWindowTitle: string = ''

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    this.showMap = this.mapData?.displayGMAP
    this.mapWindowTitle = this.mapData?.mapTitle;
  }

  closeDialogue() {
    this.closeMapDialogue.emit(
      {
        "gMapDialogueVisible": false
      });
  }
}
